import React, { PropTypes } from 'react';
import Dropdown from 'common/components/Dropdown';
import cx from 'classnames';

const getRefTechName = worker => `${worker.display_name}`;

const renderDefault = () => <div className="default text">Technicien</div>;

const renderWorker = worker => (
  <div key={worker.id} data-value={worker.id} className="item">
    {getRefTechName(worker)}
  </div>
);

export const WorkerDropdown = ({ site, workers, hasError, onChange }) => {
  const fieldClassName = cx('six wide field', {
    error: hasError,
  });

  return (
    <div className={fieldClassName}>
      <label>Technicien référent</label>
      <Dropdown
        name="ref_tech_id"
        value={site.ref_tech_id || null}
        canDelete
        items={workers}
        renderDefault={renderDefault}
        renderItem={renderWorker}
        onChange={onChange}
      />
    </div>
  );
};

WorkerDropdown.propTypes = {
  site: PropTypes.object.isRequired,
  workers: PropTypes.array.isRequired,
  hasError: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default WorkerDropdown;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases/form/components/WorkerDropdown.js